window.WelcomeStatusAPI =  new function() {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsAnnouncements : publicConfiguration.Announcements;
    _protected.setApiUrl(url);

    var result;

    self.resetResults = function(){
        result = undefined;
    };

    self.getStatus = function() {
        var deferred = $q.defer();

        if (result) {
            deferred.resolve(result);
        }
        else {
            _protected.request("users/announcements", "GET").then(function (res) {
                var status = (res && res.data && res.data.data && res.data.data.announcements) || {};
                result = status;
                deferred.resolve(status);
            });
        }

        return deferred.promise;
    };

    self.dismiss = function (announcementId) {
        return _protected.uniqueRequest("users/announcements/" + announcementId + "/dismiss", "POST");
    };

    self.requestDemo = function (announcementId, params) {
        return _protected.request("users/announcements/" + announcementId + "/request_demo", "POST", params);
    }

}
